<template>
  <div class="step-dynamic__progress">
    <svg style="width: 240px; height: 240px" viewBox="0 0 240 240">
      <!-- Фоновый круг -->
      <circle
        transform="rotate(135 120 120)"
        r="80"
        cx="120"
        cy="120"
        fill="none"
        stroke-width="20"
        stroke="#0101010A"
        :stroke-dasharray="strokeDashArray"
        :stroke-dashoffset="strokeDashArray * 0.25"
        stroke-linecap="round"
      ></circle>

      <!-- Прогресс -->
      <circle
        transform="rotate(135 120 120)"
        r="80"
        cx="120"
        cy="120"
        fill="none"
        stroke-width="20"
        :stroke="fillColor"
        :stroke-dasharray="strokeDashArray"
        :stroke-dashoffset="dashOffset"
        stroke-linecap="round"
        v-if="percentage > 0"
      ></circle>

      <!-- Текст -->
      <text x="120" y="80"  font-size="12" text-anchor="middle" fill="#999">
        {{ formattedDate }}
      </text>
      <text x="120" y="125" font-size="34" text-anchor="middle" fill="#444" font-weight="bold">
        {{ value }}
      </text>
      <text x="120" y="150" font-family="Arial" font-size="12" text-anchor="middle" fill="#999">
        из {{ targetSteps }}
      </text>
    </svg>
  </div>
</template>

<script>

const colors = {
  success: '#71D13D',
  warning: '#93DE64',
  danger: '#B5EB8F',
  default: 'rgba(0,0,0, 0.09)',
};

export default {
  props: {
    value: {
      type: Number,
      required: true,
      default: 0,
    },
    targetSteps: {
      type: Number,
      required: true,
    },
    date: {
      type: String,
    },
    strokeDashArray: {
      type: Number,
      default: 502.65,
    },
  },
  computed: {
    percentage() {
      return this.targetSteps > 0 ? Math.min(100, (this.value / this.targetSteps) * 100) : 0;
    },
    dashOffset() {
      // Полная длина окружности
      const circumference = this.strokeDashArray;
      // Доступная для заполнения часть (75% окружности)
      const availableArc = circumference * 0.75;
      // Вычисляем смещение для процента от доступной части
      const progressOffset = availableArc * (1 - (this.percentage / 100));
      // Добавляем смещение для скрытой части (25% окружности)
      return progressOffset + (circumference * 0.25);
    },
    fillColor() {
      if (this.percentage >= 100) {
        return colors.success;
      }
      if (this.percentage >= 50) {
        return colors.warning;
      }
      return colors.danger;
    },
    formattedDate() {
      const inputDate = new Date(this.date);
      const today = new Date();
      // Проверка на совпадение с сегодняшней датой
      if (inputDate.toDateString() === today.toDateString()) {
        return 'Сегодня';
      }

      // Форматирование даты
      const year = inputDate.getFullYear();
      const month = String(inputDate.getMonth() + 1).padStart(2, '0');
      const day = String(inputDate.getDate()).padStart(2, '0');

      // Проверка на текущий год
      if (year === today.getFullYear()) {
        return `${day}.${month}`;
      }

      return `${day}.${month}.${year}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.progressbar__stroke {
  transition: stroke-dashoffset 0.5s ease-in-out;
}
.step-dynamic__progress {
  height: 296px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
